import {
  TrailerDeckHeightField,
  TrailerEmptyWeightField,
  TrailerGroundClearanceField,
  TrailerHeightField,
  TrailerKingpinSetbackLengthField,
  TrailerKingpinSettingLengthField,
  TrailerLengthField,
  TrailerRegisteredWeightField,
  TrailerWheelbaseLengthField,
  TrailerWidthField,
} from '@src/permitField/TrailerDimensionFields';
import {
  IsDualLaneField,
  IsTrunnionAxleField,
  TrailerAxleCountField,
  TrailerLicensePlateField,
  TrailerLicensePlateStateField,
  TrailerLicensePlateTypeField,
  TrailerMakeField,
  TrailersFormName,
  TrailerTypeField,
  TrailerUnitNumberField,
  TrailerVINField,
  TrailerYearField,
} from '@src/permitField/TrailerInformationFields';
import * as yup from 'yup';

export const trailerInformationFormField = {
  [TrailerUnitNumberField.fieldName]: TrailerUnitNumberField.validator,
  [TrailerYearField.fieldName]: TrailerYearField.validator,
  [TrailerMakeField.fieldName]: TrailerMakeField.validator,
  [TrailerVINField.fieldName]: TrailerVINField.validator,
  [TrailerTypeField.fieldName]: TrailerTypeField.validator,
};
const trailerInformationWithAxleCount = {
  ...trailerInformationFormField,
  [TrailerAxleCountField.fieldName]: TrailerAxleCountField.validator,
};
export const trailerInformationFields = trailerInformationWithAxleCount;

export const trailerLicensePlateFields = {
  [TrailerLicensePlateField.fieldName]: TrailerLicensePlateField.validator,
  [TrailerLicensePlateStateField.fieldName]:
    TrailerLicensePlateStateField.validator,
  [TrailerLicensePlateTypeField.fieldName]:
    TrailerLicensePlateTypeField.validator,
};

export const trailerDimensionsFields = {
  [TrailerLengthField.fieldName]: TrailerLengthField.validator,
  [TrailerWidthField.fieldName]: TrailerWidthField.validator,
  [TrailerHeightField.fieldName]: TrailerHeightField.validator,
  [TrailerWheelbaseLengthField.fieldName]:
    TrailerWheelbaseLengthField.validator,
  [TrailerDeckHeightField.fieldName]: TrailerDeckHeightField.validator,
  [TrailerGroundClearanceField.fieldName]:
    TrailerGroundClearanceField.validator,
  [TrailerKingpinSetbackLengthField.fieldName]:
    TrailerKingpinSetbackLengthField.validator,
  [TrailerKingpinSettingLengthField.fieldName]:
    TrailerKingpinSettingLengthField.validator,
  [TrailerEmptyWeightField.fieldName]: TrailerEmptyWeightField.validator,
  [TrailerRegisteredWeightField.fieldName]:
    TrailerRegisteredWeightField.validator,
} as const;

export const globalTrailerFields = {
  [IsDualLaneField.fieldName]: IsDualLaneField.validator,
  [IsTrunnionAxleField.fieldName]: IsTrunnionAxleField.validator,
};

export const trailerFields = {
  ...trailerInformationFields,
  ...trailerLicensePlateFields,
  ...trailerDimensionsFields,
};

//This is the schema when completing an order form
export const TrailerInformationSchema = yup.object().shape(trailerFields);

export const TrailerInformationInputsSchema = yup.object().shape({
  ...globalTrailerFields,
  [TrailersFormName]: yup.array(TrailerInformationSchema),
});
